import { render, staticRenderFns } from "./FabricAssets.vue?vue&type=template&id=af2d41b8&scoped=true"
import script from "./FabricAssets.vue?vue&type=script&lang=js"
export * from "./FabricAssets.vue?vue&type=script&lang=js"
import style0 from "./FabricAssets.vue?vue&type=style&index=0&id=af2d41b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2d41b8",
  null
  
)

export default component.exports